import { render, staticRenderFns } from "./MultiChart.vue?vue&type=template&id=06124e12&scoped=true&"
import script from "./MultiChart.vue?vue&type=script&lang=js&"
export * from "./MultiChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06124e12",
  null
  
)

export default component.exports